import React from "react";
import { useSelector } from "react-redux";
import CartItem from "./CartItem";

const Cart = () => {
    const cart = useSelector(state => state.cart.cartItems);
    const products = useSelector(state => state.products.productItems);
    const totalItem = cart.reduce((total, item) => total + item.quantity, 0);
    const totalPrice = cart.reduce((total, item) => {
        const product = products.find(product => product.id === item.productId);
        return total + product.price * item.quantity;
    }, 0);

    return (
        <div
            className="col-span-12 sm:col-span-12 md:col-span-5 lg:col-span-4 xxl:col-span-4"
        >
            <div
                className="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4"
            >
                {cart.map(cartItem => <CartItem key = {cartItem.productId} cartItem = {cartItem} />)}

                <div
                    className="flex justify-center items-center text-center"
                >
                    <div className="text-xl font-semibold">
                        <p>Total Item</p>
                        <p className="text-5xl">{ totalItem }</p>
                    </div>
                </div>
            </div>
            <div
                className="bg-white py-4 px-4 shadow-md rounded-lg my-4 mx-4"
            >
                <div
                    className="flex justify-center items-center text-center"
                >
                    <div className="text-xl font-semibold">
                        <p>Total Price</p>
                        <p className="text-5xl">{ totalPrice }</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Cart;